$(function () {
  var count = 40;
  $('.news_text.pc').each(function () {
    var thisText = $(this).text();
    var textLength = thisText.length;
    if (textLength > count) {
      var showText = thisText.substring(0, count);
      var insertText = showText += '…';
      $(this).html(insertText);
    };
  });



  // $('.news_text.pc').each(function () {
  //   var thisText = $(this).text();
  //   var textLength = thisText.length;
  //   if (textLength > count) {
  //     var showText = thisText.substring(0, count);
  //     var insertText = showText += '…';
  //     $(this).html(insertText);
  //   };
  // });

  function getSliderRecoSettings() {
    return {
      slidesToShow: 4,
      autoplay: false,
      fade: false,
      dots: true,
      arrows: true,
      appendArrows: $('.recommend__arrows'),
      appendDots: $('.recommend__dots'),
      variableWidth: true, //左寄せというかcssの横幅のサイズになってる？
      prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16.448" height="31.697" viewBox="0 0 16.448 31.697"><path d="M0,15,15,0,30,15" transform="translate(0.6 30.849) rotate(-90)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/></svg></button>',
      nextArrow: '<button class=”slick-next”><svg xmlns="http://www.w3.org/2000/svg" width="16.449" height="31.697" viewBox="0 0 16.449 31.697"><path d="M698.511,2378.694l15,15,15-15" transform="translate(-2377.845 729.36) rotate(-90)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/></svg></button>',
    }
  }
  function getSliderRecoSettings2() {
    return {
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      fade: false,
      dots: true,
      arrows: true,
      appendArrows: $('.recommend__arrows'),
      appendDots: $('.recommend__dots'),
      variableWidth: true, //左寄せというかcssの横幅のサイズになってる？
      prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16.448" height="31.697" viewBox="0 0 16.448 31.697"><path d="M0,15,15,0,30,15" transform="translate(0.6 30.849) rotate(-90)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/></svg></button>',
      nextArrow: '<button class=”slick-next”><svg xmlns="http://www.w3.org/2000/svg" width="16.449" height="31.697" viewBox="0 0 16.449 31.697"><path d="M698.511,2378.694l15,15,15-15" transform="translate(-2377.845 729.36) rotate(-90)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/></svg></button>',
    }
  }
  function sliderRecoSetting() {
    var width = $(window).width();
    var sliderClass = '.recommend__content';

    var width = $(window).width();
    if (width >= 768) {
      $(sliderClass).not('.slick-initialized').slick(getSliderRecoSettings());
    } else {
      $(sliderClass).not('.slick-initialized').slick(getSliderRecoSettings2());
    }

    setTimeout(function () {
      var rep = 0;
      $(sliderClass + ' li').each(function () {
        var itemHeight = parseInt($(this).innerHeight());
        if (itemHeight > rep) {
          rep = itemHeight;
        };
      });
      $(sliderClass + ' li').css({ 'min-height': (rep) });
    }, 5000);
  }

  sliderRecoSetting();

  function getSliderSettings() {
    return {
      slidesToShow: 1,
      autoplay: true,
      fade: false,
      dots: true,
      arrows: true,
      appendArrows: $('.pickup__arrows'),
      appendDots: $('.pickup__dots'),
      prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16.448" height="31.697" viewBox="0 0 16.448 31.697"><path d="M0,15,15,0,30,15" transform="translate(0.6 30.849) rotate(-90)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/></svg></button>',
      nextArrow: '<button class=”slick-next”><svg xmlns="http://www.w3.org/2000/svg" width="16.449" height="31.697" viewBox="0 0 16.449 31.697"><path d="M698.511,2378.694l15,15,15-15" transform="translate(-2377.845 729.36) rotate(-90)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"/></svg></button>'
    }
  }
  function sliderSetting() {
    var width = $(window).width();
    var sliderClass = '.pickup__content';
    if (width >= 768) {
      if ($(sliderClass).hasClass('slick-initialized')) {
        $(sliderClass).slick('unslick');
      }
    } else {
      $(sliderClass).not('.slick-initialized').slick(getSliderSettings());
    }
  }

  sliderSetting();



  // レシピPC用処理
  let recipeImg = '.pc .recipe__content--img';
  let recipeList = '.pc .recipe__content--list li';
  $(recipeList).each(function (i, v) {
    let mainList = $(this);
    mainList.find('a').on('click', function () {
      let aClickItem = $(this);

      if (mainList.hasClass('active')) {
        let href = aClickItem.attr('href');
        window.location.href = href;
      }

      $(recipeList).each(function (i, v) {
        let roopList = $(this);
        roopList.removeClass('active');
      });

      let href = aClickItem.attr('href');
      let src = aClickItem.find('img').attr('src');
      $(recipeImg).find('a').attr('href', href);
      $(recipeImg).find('img').attr('src', src);
      mainList.addClass('active');
      return false;
    });

    if (mainList.hasClass('active')) {
      let href = mainList.find('a').attr('href');
      let src = mainList.find('img').attr('src');
      $(recipeImg).find('a').attr('href', href);
      $(recipeImg).find('img').attr('src', src);
    }
  })

  // レシピSP用処理
  let recipeImg2 = '.sp .recipe__content--img';
  let recipeList2 = '.sp .recipe__content--thumbnail li';
  let recipeTextList = '.sp .recipe__content--list li';
  $(recipeList2).each(function (i, v) {
    let mainList = $(this);
    mainList.find('a').on('click', function () {
      let aClickItem = $(this);
      if (mainList.hasClass('active')) {
        let href = aClickItem.attr('href');
        window.location.href = href;
      }
      $(recipeList2).each(function (i, v) {
        let roopList = $(this);
        roopList.removeClass('active');
      });
      $(recipeTextList).each(function (i, v) {
        let roopList = $(this);
        roopList.removeClass('active');
      });

      let href = aClickItem.attr('href');
      let src = aClickItem.find('img').attr('src');
      $(recipeImg2).find('a').attr('href', href);
      $(recipeImg2).find('img').attr('src', src);
      mainList.addClass('active');
      $(recipeTextList).eq(mainList.index()).addClass('active');

      return false;
    });

    if (mainList.hasClass('active')) {
      let href = mainList.find('a').attr('href');
      let src = mainList.find('img').attr('src');
      $(recipeImg2).find('a').attr('href', href);
      $(recipeImg2).find('img').attr('src', src);
    }
  })



  $('.whatsnew__content a.wn_movie').on('click', function () {
    let wnMovie = $(this);
    let articleId = wnMovie.attr('href').split('#').slice(-1)[0];
    $('[data-modal="' + articleId + '"]').fadeIn().css({ 'display': 'flex' });
    $('body').addClass('scroll_lock');
    return false;
  });

  $('.whatsnew-modal .whatsnew-modal__movie-content--close,.whatsnew-modal--overlay').on('click', function () {
    $('.whatsnew-modal').fadeOut();
    $('body').removeClass('scroll_lock');
    let modal = $(this).closest('.whatsnew-modal');
    var $video = modal.find('.whatsnew-modal__movie-content__mian--youtube iframe');

    videoControl("pauseVideo");
    function videoControl(action) {
      console.log($video[0]);
      var $playerWindow = $video[0].contentWindow;
      $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
    }
  })


  $(window).resize(function () {
    sliderSetting();
    sliderRecoSetting();
    // sliderSettingInst();

  });
});

